<!-- Generic Error -->
<div
  style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center"
>
  <h2>Internal Error</h2>
  <h4>There was an error processing your request. Please try again later or contact helpdesk.</h4>
</div>
<!-- Generic Error -->
